__turbopack_context__.v({
  "disabled": "ddChZW_disabled",
  "link": "ddChZW_link",
  "loading": "ddChZW_loading",
  "primary": "ddChZW_primary",
  "quickAdd": "ddChZW_quickAdd",
  "root": "ddChZW_root",
  "secondary": "ddChZW_secondary",
  "slim": "ddChZW_slim",
});
